import React, { useState } from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import styled from "@emotion/styled"
import HeaderImage from "./HeaderImage"
import { FaChevronDown, FaTimes } from "react-icons/fa"

const menuBreakPoint = "565px"

const StyledHeader = styled.header`
  width: 100%;
  margin: 0;
  padding: 10px;
  background: var(--bgDark);
  box-shadow: 0px 2px 4px -1px rgba(var(--rgb),var(--rgb),var(--rgb), calc(0.1 * var(--a))), 0px 4px 5px 0px rgba(var(--rgb),var(--rgb),var(--rgb), calc(0.7 * var(--a))), 0px 1px 10px 0px rgba(var(--rgb),var(--rgb),var(--rgb), calc(0.6 * var(--a)));
  transition: color 250ms ease-in-out, background-color 250ms ease-in-out,
      border-color 250ms ease-in-out;

  @media screen and (max-width: 767px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    z-index: 50;
  }
`

const Container = styled.div`
  margin: 0 auto;
  max-width: 960px;
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`

const Navigation = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  a {
    background-color: transparent;
    cursor: pointer;
    display: block;
    align-self: center;
    color: var(--navLinks);
    text-decoration: none;
    font-family: "Trade Winds", cursive;
    font-weight: 400;
    font-style: normal;
    font-size: 24px;
    padding: 0 20px;
    line-height: 100px;
    text-align: center;
    transition: color 250ms ease-in-out, background-color 250ms ease-in-out,
      border-color 250ms ease-in-out;
  }
  a:hover {
    background-color: rgba(var(--rgb),var(--rgb),var(--rgb), calc(0.075 * var(--a)));
    background: var(--starburst);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    color: var(--navLinksHover);
    text-shadow: 2px 2px var(--navLinks);
  }
  @media screen and (max-width: ${menuBreakPoint}) {
    display: none;
  }
`

const MobileNavigation = styled.nav`
  display: none;
  @media screen and (max-width: ${menuBreakPoint}) {
    display: flex;
  }
`

const DropDownContent = styled.div`
  position: relative;
  display: inline-block;
`

const DropDownIcon = styled.label`
  background-color: transparent;
  text-align: center;
  border: none;
  font-size: 30px;
  padding: 0 40px;
  height: 100px;
  line-height: 100px;
  position: relative;
  display: block;
  cursor: pointer;
  transition: background-color 200ms ease-in-out;
  color: var(--navLinks);
  transition: color 250ms ease-in-out, background-color 250ms ease-in-out,
    border-color 250ms ease-in-out;
  &:hover {
    background-color: rgba(var(--rgb),var(--rgb),var(--rgb), calc(0.075 * var(--a)));
  }
`

const DropDownCheckBox = styled.input`
  position: absolute !important;
  left: -9999px !important;
  &:checked ~ div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &:checked + label {
    background-color: background-color: rgba(var(--rgb),var(--rgb),var(--rgb), calc(0.075 * var(--a)));
    transition: color 250ms ease-in-out, background-color 250ms ease-in-out,
      border-color 250ms ease-in-out;
  }
`

const DropDownLinks = styled.div`
  display: none;
  position: fixed;
  background-color: var(--accent);
  box-shadow: 0px 8px 16px 0px rgba(var(--rgb),var(--rgb),var(--rgb), calc(0.1 * var(--a)));
  z-index: 5;
  text-align: center;
  top: 120px;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: calc(100vh - 120px);
  cursor: pointer;
  transition: color 250ms ease-in-out, background-color 250ms ease-in-out,
    border-color 250ms ease-in-out;
  a {
    font-family: "Trade Winds", cursive;
    font-weight: 400;
    font-style: normal;
    font-size: 24px;
    color: var(--navLinks);
    background-color: var(--accent);
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    cursor: pointer;
    width: 100%;
    transition: color 250ms ease-in-out, background-color 250ms ease-in-out,
      border-color 250ms ease-in-out;
  }
  a:hover {
    color: var(--dropDownLinks);
    background-color: rgba(var(--rgb),var(--rgb),var(--rgb), calc(0.1 * var(--a)));
  }
`

const NavLinks = () => (
  <>
    <Link to="/" aria-label="Home Page">
      Home
    </Link>
    <Link to="/about/" aria-label="About Page">
      About
    </Link>
    <Link to="/work/" aria-label="Work Page">
      Work
    </Link>
    <Link to="/blog/" aria-label="Blog Page">
      Blog
    </Link>
  </>
)

const Header = ({ siteTitle }) => {
  const [checked, setCheck] = useState(false);
  
  return (
    <StyledHeader>
      <Container>
        <Link to="/" aria-label="Home Page">
          <HeaderImage alt={siteTitle} />
        </Link>
        <Navigation>
          <NavLinks />
        </Navigation>
        <MobileNavigation>
          <DropDownContent>
            <DropDownCheckBox
              id="dropcheck"
              name="dropcheck"
              type="checkbox"
              aria-label={
                checked ? "Click to Hide Menu" : "Click to Show Menu"
              }
              onClick={() => setCheck(!checked)}
            />
            <DropDownIcon htmlFor="dropcheck">
              {checked ? <FaTimes /> : <FaChevronDown />}
            </DropDownIcon>
            <DropDownLinks>
              <NavLinks />
            </DropDownLinks>
          </DropDownContent>
        </MobileNavigation>
      </Container>
      
    </StyledHeader>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
